// extracted by mini-css-extract-plugin
export default {"QuantityInputBlock":"QuantityInputBlockSApAr","quantityInputBlock":"QuantityInputBlockSApAr"};